const evite = window.evite = window.evite || {};

function consoleByMethodName(methodName, args) {
  const console = evite.global.console;

  if (process.env.LOGGING_ENABLED && console) {
    if (console[methodName]) {
      console[methodName].apply(console, args);
    }
    else if (methodName !== 'log') {
      consoleByMethodName('log', args);
    }
  }
}

export function log(...args) {
  consoleByMethodName('log', args);
}

export function debug(...args) {
  consoleByMethodName('debug', args);
}

export function info(...args) {
  consoleByMethodName('info', args);
}

export function error(...args) {
  consoleByMethodName('error', args);
}

export function trace(...args) {
  consoleByMethodName('trace', args);
}

export function warn(...args) {
  consoleByMethodName('warn', args);
}

export function assert(value, message) {
  if(value){
    return value;
  }

  if(process.env.NODE_ENV === 'develop'){
    throw new Error('Assertion Error: ' + message);
  } else {
    consoleByMethodName('assert', [value, message || '']);
  }
}

function assertType(value, type){
  let valueType = typeof value;
  let message = `Expected type (${type}), got (${valueType})`;
  assert(valueType === type, message);
  return value;
}

export function assertString(value) {
  return assertType(value, 'string');
}

export function assertNumber(value) {
  return assertType(value, 'number');
}

export function assertBoolean(value) {
  return assertType(value, 'boolean');
}

export function assertObject(value) {
  return assertType(value, 'object');
}

export function assertFunction(value) {
  let valueType = typeof value;
  let message = `Expected type (function), got (${valueType})`;
  assert(typeof value === 'function'|| value instanceof Function, message);
  return value;
}

export function assertInstanceOf(value, instanceConstructor) {
  let message = `Expected value to be a instance of ${instanceConstructor.name || instanceConstructor}, got: ${value}`;
  assert(value instanceof instanceConstructor, message);
  return value;
}

Object.assign(evite, exports);



// WEBPACK FOOTER //
// ./assets/es6/common/evite/log.es6